import {
  MASS_UPLOAD_SERVICES,
  MASS_UPLOAD_SERVICES_FAILURE,
  MASS_UPLOAD_SERVICES_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const massUploadServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case MASS_UPLOAD_SERVICES:
      return { ...state, loading: true };
    case MASS_UPLOAD_SERVICES_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case MASS_UPLOAD_SERVICES_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default massUploadServicesReducer;
